import React, { useState } from "react";
import { motion } from "framer-motion";

const WifiSheet = ({ settings, onClose, t }) => {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(settings?.wifiPassword || "");
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <motion.div
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-end justify-center"
      onClick={onClose}
      data-testid="wifi-sheet"
    >
      <motion.div
        initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }}
        transition={{ type: "spring", damping: 30, stiffness: 280 }}
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-xl bg-zbeach-bg rounded-t-3xl pb-8"
      >
        <div className="flex justify-center pt-2 pb-1"><div className="w-12 h-1.5 bg-zbeach-muted/30 rounded-full" /></div>
        <div className="px-6 pt-3">
          <div className="flex items-center justify-between mb-2">
            <h2 className="font-serif text-2xl text-zbeach-dark font-semibold flex items-center gap-2"><i className="fa-solid fa-wifi text-zbeach-turquoise" /> {t.wifiTitle}</h2>
            <button onClick={onClose} className="w-9 h-9 rounded-full bg-zbeach-surface border border-zbeach-gold/20 flex items-center justify-center"><i className="fa-solid fa-xmark" /></button>
          </div>
          <div className="mt-6 space-y-4">
            <div className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl p-4">
              <div className="text-xs uppercase tracking-wider text-zbeach-muted">{t.wifiName}</div>
              <div className="font-serif text-xl text-zbeach-dark mt-1" data-testid="wifi-name">{settings?.wifiName}</div>
            </div>
            <div className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl p-4 flex items-center justify-between gap-3">
              <div>
                <div className="text-xs uppercase tracking-wider text-zbeach-muted">{t.wifiPassword}</div>
                <div className="font-serif text-xl text-zbeach-dark mt-1 tracking-wider" data-testid="wifi-password">{settings?.wifiPassword}</div>
              </div>
              <button onClick={copy} className="px-4 py-2 rounded-full bg-zbeach-turquoise text-white text-sm font-medium" data-testid="wifi-copy">
                <i className={`fa-solid ${copied ? "fa-check" : "fa-copy"} mr-1`} /> {copied ? t.copied : t.copy}
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default WifiSheet;
